import { IApiKey } from '../../types';
import {
  ApiKeysActionTypes,
  GenerateApiKeyRequestAction,
  GenerateApiKeySuccessAction,
  GenerateApiKeyFailureAction,
  GetApiKeyRequestAction,
  GetApiKeySuccessAction,
  GetApiKeyFailureAction,
  ClearApiKeysStateAction,
} from './apiKeys.types';

// Generate API Key Actions
export const generateApiKeyRequest = (): GenerateApiKeyRequestAction => ({
  type: ApiKeysActionTypes.GENERATE_API_KEY_REQUEST,
});

export const generateApiKeySuccess = (
  apiKey: string
): GenerateApiKeySuccessAction => ({
  type: ApiKeysActionTypes.GENERATE_API_KEY_SUCCESS,
  payload: apiKey,
});

export const generateApiKeyFailure = (
  error: string
): GenerateApiKeyFailureAction => ({
  type: ApiKeysActionTypes.GENERATE_API_KEY_FAILURE,
  payload: error,
});

// Get API Key Actions
export const getApiKeyRequest = (): GetApiKeyRequestAction => ({
  type: ApiKeysActionTypes.GET_API_KEY_REQUEST,
});

export const getApiKeySuccess = (apiKey: IApiKey): GetApiKeySuccessAction => ({
  type: ApiKeysActionTypes.GET_API_KEY_SUCCESS,
  payload: apiKey,
});

export const getApiKeyFailure = (error: string): GetApiKeyFailureAction => ({
  type: ApiKeysActionTypes.GET_API_KEY_FAILURE,
  payload: error,
});

// Clear Actions
export const clearApiKeysState = (): ClearApiKeysStateAction => ({
  type: ApiKeysActionTypes.CLEAR_API_KEYS_STATE,
});
